import React, { useState } from 'react';
import { LockFill } from 'react-bootstrap-icons';
import './Login.css';

const Login = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const correctPassword = 'MTJ31052025';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      onLogin();
    } else {
      alert('Incorrect password');
    }
  };

  return (
    <div className="login-container login">
      <div className="login-card">

        <h2 className="login-title">R&N</h2>
        <div className="icon-container">
          <LockFill className="lock-icon" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          <button type="submit" className="login-button">
            Log in
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;